/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_1Inputs */

const en_cp_ask_1 = /** @type {(inputs: Cp_Ask_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One point of contact (lecturer/coordinator) and a kickoff slot in the schedule`)
};

const id_cp_ask_1 = /** @type {(inputs: Cp_Ask_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu PIC (dosen/koordinator) dan slot kickoff di jadwal`)
};

/**
* | output |
* | --- |
* | "One point of contact (lecturer/coordinator) and a kickoff slot in the schedule" |
*
* @param {Cp_Ask_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_1 = /** @type {((inputs?: Cp_Ask_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_1(inputs)
	return en_cp_ask_1(inputs)
});